import React, { useEffect } from "react";
import { usePageHistoryStore } from "./stores/usePageHistoryStore";
import HistoryFilters from "./components/HistoryFilters";
import HistorySearch from "./components/HistorySearch";
import HistoryList from "./components/HistoryList";

// Компонент історії сторінки
const PageHistory = ({ subjects, config, contextFilters }) => {
  // Отримуємо дані та дії зі стору
  const init = usePageHistoryStore((state) => state.init);
  const isOpen = usePageHistoryStore((state) => state.isOpen);
  const toggleSidebar = usePageHistoryStore((state) => state.toggleSidebar);

  // Ініціалізуємо стор один раз, передаючи йому 'subjects' з props
  useEffect(() => {
    init(subjects, config, contextFilters);
  }, [init, subjects, config, contextFilters]);

  return (
    <div className="history-container">
      <button
        className={`history-trigger-button ${isOpen ? "open" : ""}`}
        onClick={toggleSidebar}
      >
        {isOpen ? "✖" : "ｉ"}
      </button>

      {isOpen && (
        <>
          <div className="history-overlay" onClick={toggleSidebar}></div>
          <aside className={`history-modal ${isOpen ? "open" : ""}`}>
            <h2 className="history-modal__header">Історія Змін</h2>

            <div className="history-modal__content">
              <HistoryFilters />
              <HistorySearch />
              <HistoryList />
            </div>
          </aside>
        </>
      )}
    </div>
  );
};

export default PageHistory;
